<template>
  <div class="mobile-party-building">
    <!-- 固定Banner图 -->
    <div class="mobile-party-header-banner">
      <img 
        :src="require('@/assets/client/partyworkbg.png')" 
        alt="党建工作"
        class="mobile-party-header-banner__image"
      />
    </div>

    <!-- 轮播图区域 -->
    <div class="mobile-party-container">
      <div class="mobile-party-banner">
        <el-carousel 
          :interval="3000" 
          arrow="never" 
          height="240px"
          v-if="bannerList && bannerList.length > 0"
        >
          <el-carousel-item 
            v-for="(item, index) in bannerList" 
            :key="index"
          >
            <img 
              :src="item.fileUrl || item.filePath" 
              :alt="`党建轮播图${index + 1}`"
              class="mobile-party-banner__image"
            />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <!-- 党支部简介 -->
    <div class="mobile-party-container">
      <section class="mobile-party-intro">
        <div class="mobile-party-card">
          <div class="mobile-party-card__header">
            <h2 class="mobile-party-card__title">
              <span class="mobile-party-card__title-icon"></span>
              党支部简介
            </h2>
          </div>
          <div class="mobile-party-card__body">
            <div 
              class="mobile-party-intro__content" 
              v-html="introduction"
              v-if="introduction"
            ></div>
            <div class="mobile-party-empty" v-else>
              <p class="mobile-party-empty__text">暂无内容</p>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- fl.jpg 图片展示 -->
    <div class="mobile-party-container">
      <div class="mobile-party-image">
        <div class="mobile-party-image__wrapper">
          <img 
            :src="require('@/assets/aboutSailHero/img/fl.jpg')" 
            alt="党建风采"
            class="mobile-party-image__img"
          />
        </div>
      </div>
    </div>

    <!-- 党建动态列表 -->
    <div class="mobile-party-container">
      <section class="mobile-party-dynamics">
        <div class="mobile-party-card">
          <div class="mobile-party-card__header">
            <h2 class="mobile-party-card__title">
              <span class="mobile-party-card__title-icon"></span>
              党建动态
            </h2>
          </div>
          <div class="mobile-party-card__body">
            <!-- 加载状态 -->
            <div class="mobile-party-loading" v-if="loading">
              <div class="mobile-party-loading__spinner"></div>
              <p class="mobile-party-loading__text">加载中...</p>
            </div>

            <!-- 动态列表 -->
            <div 
              class="mobile-party-dynamics__list" 
              v-else-if="dynamicsList && dynamicsList.length > 0"
            >
              <div
                v-for="(item, index) in dynamicsList"
                :key="item.id || index"
                class="mobile-party-dynamics__item"
                @click="openDetail(item, index)"
              >
                <div class="mobile-party-dynamics__header">
                  <h3 class="mobile-party-dynamics__title">{{ item.about_name }}</h3>
                  <span class="mobile-party-dynamics__badge">动态</span>
                </div>
                <div class="mobile-party-dynamics__meta">
                  <span class="mobile-party-dynamics__date" v-if="item.update_time">
                    {{ formatDate(item.update_time) }}
                  </span>
                  <span class="mobile-party-dynamics__action">查看详情</span>
                </div>
              </div>
            </div>

            <!-- 空状态 -->
            <div class="mobile-party-empty" v-else>
              <div class="mobile-party-empty__icon">📋</div>
              <p class="mobile-party-empty__text">暂无党建动态</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobilePartyBuildingWork",
  data() {
    return {
      bannerList: [],           // 轮播图列表
      introduction: '',         // 党支部简介
      dynamicsList: [],         // 党建动态列表
      loading: false            // 加载状态
    };
  },
  methods: {
    /**
     * 获取轮播图数据
     */
    fetchCarouselPictures() {
      const _this = this;
      _this.$api.post(
        "/Client/getCarouselPictures",
        {},
        function (res) {
          if (res.code === "200") {
            _this.bannerList = res.data || [];
          }
        },
        function (error) {
          console.error('获取轮播图失败:', error);
        }
      );
    },

    /**
     * 获取党支部简介
     */
    fetchIntroduction() {
      const _this = this;
      _this.$api.post(
        "/Client/getIntroduction",
        {},
        function (res) {
          if (res.code === "200") {
            _this.introduction = res.data.about_content || '';
          }
        },
        function (error) {
          console.error('获取党支部简介失败:', error);
        }
      );
    },

    /**
     * 获取党建动态列表
     */
    fetchPartyDynamics() {
      const _this = this;
      _this.loading = true;
      _this.$api.post(
        "/Client/getPartyBuildingDynamics",
        { 
          pageSize: 20,  // 加载20条数据，供滚动浏览
          pageIndex: 1 
        },
        function (res) {
          _this.loading = false;
          if (res.code === "200") {
            _this.dynamicsList = res.data || [];
          }
        },
        function (error) {
          _this.loading = false;
          console.error('获取党建动态失败:', error);
        }
      );
    },

    /**
     * 打开动态详情页
     * @param {Object} item - 动态项数据
     * @param {Number} index - 索引
     */
    openDetail(item, index) {
      const _this = this;
      const list = _this.dynamicsList;
      const listStr = JSON.stringify(list);
      
      const { href } = _this.$router.resolve({
        path: "/Client/CorporateCultureDetails",
        query: {
          id: item.id,
          bigTitle: "党建工作",
          modelitem: "党建动态",
          about_content: item.about_content,
          about_name: item.about_name,
          update_time: item.update_time,
          list: listStr,
          index: index,
          from: 'partyBuilding'
        }
      });
      // 使用 window.open 在新窗口中打开该 URL
      window.open(href, '_self');
    },

    /**
     * 格式化日期
     * @param {String} dateStr - 日期字符串
     * @return {String} 格式化后的日期
     */
    formatDate(dateStr) {
      if (!dateStr) return '';
      
      try {
        const date = new Date(dateStr);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      } catch (error) {
        return dateStr;
      }
    }
  },

  mounted() {
    // 页面加载时获取所有数据
    this.fetchCarouselPictures();
    this.fetchIntroduction();
    this.fetchPartyDynamics();
  }
};
</script>

<style scoped>
@import '../../../assets/aboutSailHero/css/party-building-mobile.css';
</style>

